import { useEffect, useState } from "react";

import { Menu, Avatar, Card, Col } from "antd-v4";
import { useCustomise } from "../../../context/customiseContext";

export default function HeaderLanguages() {
  // Context
  const {language, setLanguage} = useCustomise()

  // Language
  const [activeLanguage, setActiveLanguage] = useState(language);
  const languages = ["en", "fr"];

  useEffect(() => {
    // Synchro avec un systeme externe au rendu (DOM, storage, timer, toast,
    // navigation) : l'etat accompagne un effet de bord qui ne peut pas remonter au rendu.
    // eslint-disable-next-line react/set-state-in-effect
    setActiveLanguage(localStorage.getItem("lp-lang") || language);
  }, [language]);

  return (
    <Col className="hp-languages hp-mr-8">
      <div className="hp-d-flex-center">
        <Avatar
          size={24}
          // eslint-disable-next-line no-undef
          src={require(`../../../assets/images/languages/${activeLanguage}.svg`)}
        />
        <span className="hp-languages-text hp-text-color-black-80 hp-text-color-dark-30 hp-text-uppercase hp-ml-8">
          {activeLanguage}
        </span>
      </div>

      <div className="hp-languages-list">
        <Card className="hp-border-color-black-40 hp-border-radius">
          <Menu>
            {languages.map(
              (item, index) =>
                item !== activeLanguage && (
                  <Menu.Item
                    key={index}
                    onClick={() => {
                      localStorage.setItem("lp-lang", item);
                      setLanguage(item);
                    }}
                  >
                    <div className="hp-d-flex-center">
                      <Avatar
                        size={24}
                        // eslint-disable-next-line no-undef
                        src={require(
                          `../../../assets/images/languages/${item}.svg`,
                        )}
                      />
                      <span className="hp-languages-text hp-text-color-black-80 hp-text-color-dark-30 hp-text-uppercase hp-ml-4">
                        {item}
                      </span>
                    </div>
                  </Menu.Item>
                ),
            )}
          </Menu>
        </Card>
      </div>
    </Col>
  );
}
